//Types
import { FileValidated } from "@dropzone-ui/react";
import { SolicitudViolenciaData, PdfsSolicitudViolencia } from "../../../interfaces/solicitudViolencia/dataInterface";

//Utilidades para verificar la data

// Verificar que la CURP tenga una estructura correcta
// export const checkCurpSolicitudViolencia = (curp: string) => {
//   const regex = /^[A-Z]{4}[0-9]{6}[A-Z]{6}[0-9]{2}$/;
//   return regex.test(curp);
// }

// Verificar que la CURP tenga una estructura correcta
export function checkCurpSolicitudViolencia(curp: string) {
  const re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
      validado = curp.match(re);

  if (!validado)  //Coincide con el formato general?
    return false;
  
  //Validar que coincida el dígito verificador
  function digitoVerificador(curp17: string) {
      //Fuente https://consultas.curp.gob.mx/CurpSP/
      let diccionario  = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
          lngSuma      = 0.0,
          lngDigito    = 0.0;
      for(let i=0; i<17; i++)
          lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
      lngDigito = 10 - lngSuma % 10;
      if (lngDigito === 10) return 0;
      return lngDigito;
  }

  if (validado[2] !== digitoVerificador(validado[1]).toString()){
    return false;
  } 
      
  return true; //Validado
}

// Verificar que el peso de los archivos no sea mayor a 10MB
export const checkFilesSizeSolicitudViolencia = (files: FileValidated[] ) => {
  let totalSize = 0;
  for (let i = 0; i < files.length; i++) {
    totalSize += files[i].file.size;
  }
  if (totalSize > 10485760) {
    return false;
  }
  return true;
}

//Utilidad para limpiar y preparar la data para enviar la solicitud.
export const preparedObjectSolicitudViolencia = (data: SolicitudViolenciaData, method: number, filesBase64: PdfsSolicitudViolencia[] ,token:string) => {
  const dataPrepared = {
    medioDeConfirmacion:{
      type: method,
      contacto: method === 1 ? data.demandingPhone : data.demandingEmail
    },
    victima: {
      nombre: data.demandingName,
      paterno: data.demandingFirstLastName,
      materno: data.demandingSecondLastName,
      celular: data.demandingPhone,
      email: data.demandingEmail,
      curp: data.demandingCurp,
    },
    generadorDeViolencia: {
      nombre: data.defendantName,
      paterno: data.defendantFirstLastName,
      materno: data.defendantSecondLastName,
      celular: data.defendantPhone,
      direccion: data.defendantAddress,
    },
    demandaSintesis: data.demandingDescription,
    captchaToken: token,
    demandaPdfs: filesBase64 as {name: string, content: string}[]
  }
  return dataPrepared;
}